import { FC, useEffect } from 'react'
import toast from 'react-hot-toast'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Api } from '../api'

const Payrix: FC = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  useEffect(() => {
    ;(async () => {
      const loadingToast = toast.loading('Handling response from Worldpay')

      try {
        await Api.post('member_portal/checkout_id', {
          checkout_id: searchParams.get('checkout_id'),
          token: searchParams.get('webPageToken'),
        })
        toast.success('Congratulations, you can sign in now.')
        navigate('/classes', { replace: true })
      } catch (error) {
        toast.error((error as Error).message)
      } finally {
        toast.dismiss(loadingToast)
      }
    })()
  }, [navigate, searchParams])

  return null
}

export { Payrix }
